/**
 * Common Webhook Schemas
 *
 * Shared types for raw provider webhook payloads.
 * These are the EXTERNAL formats - what providers actually send us.
 *
 * DATABASE-FIRST: Status mappings derived from provider documentation + observed behavior
 * Source: payment-service/src/webhooks/*.ts handlers
 */
import { z } from 'zod';
// =============================================================================
// PROVIDER STATUS MAPPINGS
// Each provider has their own status strings
// =============================================================================
/**
 * FastPay raw status values
 * Source: FastPay API documentation
 */
export const fastpayRawStatusValues = ['approve', 'cancel', 'check'];
export const fastpayRawStatusSchema = z.enum(fastpayRawStatusValues);
/**
 * NirvanaPay raw status values
 * Source: NirvanaPay API checkStatus response
 */
export const nirvanaRawStatusValues = [
    'SUCCESS',
    'COMPLETED',
    'ERROR',
    'FAILED',
    'CREATED',
    'ACCEPTED',
    'PENDING',
    'APPEAL',
];
export const nirvanaRawStatusSchema = z.enum(nirvanaRawStatusValues);
/**
 * Collybus raw status values
 * Source: Collybus webhook payload
 */
export const collybusRawStatusValues = [
    'success',
    'completed',
    'cancelled',
    'canceled',
    'expired',
    'failed',
    'processing',
];
export const collybusRawStatusSchema = z.enum(collybusRawStatusValues);
/**
 * EasySend/1Pays raw status values (Platcore platform)
 * Source: EasySend webhook payload status.name
 */
export const easysendRawStatusValues = [
    'completed',
    'canceled',
    'cancelled',
    'refunded',
    'expired',
    'failed',
    'queued',
    'new',
    'pending',
    'paid', // NOT terminal - waiting for trader confirmation
];
export const easysendRawStatusSchema = z.enum(easysendRawStatusValues);
// =============================================================================
// WEBHOOK TYPE
// =============================================================================
export const webhookTypeValues = ['deposit', 'payout'];
export const webhookTypeSchema = z.enum(webhookTypeValues);
// =============================================================================
// PROVIDER CODES
// These are the internal codes we use (method field in PAYMENT_PROVIDERS)
// =============================================================================
export const providerCodeValues = [
    'fservice', // FastPay
    'fservice_tjs', // FastPay TJS
    'nservice', // NirvanaPay
    'cservice', // Collybus
    'eservice', // EasySend
    'oservice', // 1Pays
    'fsl', // FastPayLong (payout only)
];
export const providerCodeSchema = z.enum(providerCodeValues);
//# sourceMappingURL=common.js.map